import { TestPackagePage } from "@/pages/TestPackagePage";

const FAQS = [
  {
    q: "Is the AWARE 4-Point enough for my tank or bore water?",
    a: "The AWARE 4-Point is a screening test — it confirms whether your tank or bore water shows signs of bacterial contamination (E. coli and Coliforms) along with pH and conductivity. If you want a broader profile of your water quality and overall system health, consider the AWARE Tank 360 or AWARE Bore 360 instead.",
  },
  {
    q: "How quickly will I get my results?",
    a: "Reports are usually returned within 1–3 days, depending on the test package, sample timing and lab workload. You'll receive both a Certificate of Analysis and a plain-English summary by email.",
  },
  {
    q: "How do I take a water sample?",
    a: "Your booking confirmation includes step-by-step sampling instructions. We supply pre-labelled sample bottles and chain-of-custody paperwork. Most customers drop their sample directly to our Noosaville lab.",
  },
  {
    q: "Does this test cover town water?",
    a: "No — Aware focuses on private water supplies (rainwater tanks and bores). Town water in our region is already tested and treated by the local council provider.",
  },
];

export default function BasicWaterSafetyCheckPage() {
  return (
    <TestPackagePage
      testId="basic"
      seo={{
        title: "AWARE 4-Point | Tank & Bore Water Screening Australia-wide",
        description:
          "Affordable tank & bore water safety screening from Aware Water Testing — supporting customers Australia-wide. E. coli, coliforms, pH and conductivity. Drop-off in Noosaville, or order the mail-out kit: we post you sterile bottles and a pre-paid express-post return tube, you collect the sample and drop it in any mailbox.",
        urlPath: "/aware-4-point",
      }}
      intro={{
        h1: "AWARE 4-Point",
        lede:
          "An affordable entry-level screening test for rainwater tank or bore water supplies — available Australia-wide. Confirms whether your private supply shows signs of bacterial contamination, along with pH and conductivity.",
      }}
      whoFor={
        "The AWARE 4-Point is designed for homeowners who want a quick, low-cost answer on whether their tank water or bore water is safe to drink. It screens for the two key indicators of contamination — E. coli and Coliforms — and reports your water's pH and conductivity. If everything comes back clean, you can have confidence in your supply; if something is detected, your plain-English report will explain what to do next."
      }
      faqs={FAQS}
    />
  );
}
